/* Meravero — "Comprar ahora": un solo clic, una sola unidad, directo al checkout.
 *
 * Tres cosas:
 *  1. Bloquea los clics repetidos mientras se procesa la compra (antes cada
 *     toque extra sumaba otra unidad al carrito: asi aparecieron carros de 4 y 6).
 *  2. Vacia el carrito antes de agregar, para que el checkout tenga exactamente
 *     lo que el cliente eligio en ese momento.
 *  3. Deja que el tema haga su propio /cart/add.js (para que el pixel y los
 *     eventos sigan funcionando) y redirige al checkout cuando termina bien.
 *
 * Para volver atras: restaura la version anterior de este archivo. */
(function () {
  if (window.__merStraightToCheckout) return;
  window.__merStraightToCheckout = true;

  var CHECKOUT_URL = '/checkout';
  var CART_URL = '/cart';
  var DELAY_MS = 150;      // deja salir los beacons de analitica antes de navegar
  var UNLOCK_MS = 8000;    // si algo falla, no dejamos el boton bloqueado para siempre

  var busy = false;
  var passthrough = false;
  var unlockTimer = null;

  function lock() {
    busy = true;
    document.documentElement.classList.add('mer-buying');
    clearTimeout(unlockTimer);
    unlockTimer = setTimeout(unlock, UNLOCK_MS);
  }

  function unlock() {
    busy = false;
    document.documentElement.classList.remove('mer-buying');
    clearTimeout(unlockTimer);
  }

  function addButtonFrom(target) {
    if (!target || !target.closest) return null;
    return target.closest('[name="add"], .mer-sticky-btn');
  }

  function realAddButton() {
    return document.querySelector('product-form [name="add"]')
        || document.querySelector('form[action*="/cart/add"] [name="add"]');
  }

  /* 1 y 2: interceptamos el clic antes que el tema. */
  document.addEventListener('click', function (e) {
    if (passthrough) return;

    var btn = addButtonFrom(e.target);
    if (!btn) return;

    if (busy) {                 // clic repetido: no hacemos nada
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    var real = btn.matches('[name="add"]') ? btn : realAddButton();
    if (!real || real.disabled) return;

    e.preventDefault();
    e.stopPropagation();
    lock();

    var done = function () {
      passthrough = true;
      try { real.click(); } finally {
        setTimeout(function () { passthrough = false; }, 0);
      }
    };

    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: '{}'
    }).then(done).catch(done);   // si falla el vaciado, seguimos igual
  }, true);

  /* 3: redireccion al checkout cuando el add-to-cart del tema termina bien. */
  var origFetch = window.fetch;
  if (typeof origFetch !== 'function') return;

  function isAddToCart(url) {
    try { return /\/cart\/add(\.js)?(\?|$)/.test(String(url)); } catch (e) { return false; }
  }

  function go(url) {
    setTimeout(function () { window.location.href = url; }, DELAY_MS);
  }

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = origFetch.apply(this, arguments);
    if (!isAddToCart(url)) return promise;

    promise.then(function (res) {
      if (!res || !res.ok) { unlock(); return; }   // error HTTP: que el tema lo muestre
      res.clone().json().then(function (data) {
        if (data && data.status) { unlock(); return; } // error de Shopify: lo maneja el tema
        go(CHECKOUT_URL);
      }).catch(function () {
        go(CART_URL);
      });
    }).catch(function () { unlock(); });

    return promise;
  };
})();